// 🔧 event_name_generator.js
// ✅ Purpose: Generates event names and slugs for LGV Demo Engine events
// ✅ Features:
// - Creates industry-specific demo event names
// - Creates safe lowercase event slugs
// - Adds timestamp uniqueness to avoid slug collisions
// - Keeps naming logic separate from Firestore event creation
// - Future-ready for OpenAI-generated event names
// - Fully block-commented for clarity and future devs

const CAR_SHOW_EVENT_NAMES = [
  "Northwest Classic Car Showcase",
  "Main Street Motors Festival",
  "Heritage Wheels Auto Show",
  "Chrome & Coffee Car Show",
  "Pacific Coast Custom Car Expo",
  "Vintage Steel Showcase",
];

export const createSafeSlug = (value = "") => {
  const baseSlug = String(value)
    .toLowerCase()
    .trim()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

  return baseSlug || "demo-event";
};

export const generateDemoEventName = ({
  industryKey = "car_show",
  industryTemplate,
  eventTitle,
} = {}) => {
  if (eventTitle?.trim()) {
    return eventTitle.trim();
  }

  if (industryTemplate?.experience?.eventName) {
    return industryTemplate.experience.eventName;
  }

  if (industryTemplate?.eventNames?.length) {
    const index = Math.floor(Math.random() * industryTemplate.eventNames.length);
    return industryTemplate.eventNames[index];
  }

  if (industryKey === "car_show") {
    const index = Math.floor(Math.random() * CAR_SHOW_EVENT_NAMES.length);

    return CAR_SHOW_EVENT_NAMES[index];
  }

  if (industryKey === "sap_ai_agents_challenge") {
    return "SAP NOW Milan — AI Agents Challenge";
  }

  return "Let's Go Vote Demo Event";
};

export const generateDemoEventSlug = ({
  eventName = "Demo Event",
  includeUniqueSuffix = true,
} = {}) => {
  const baseSlug = createSafeSlug(eventName);

  if (!includeUniqueSuffix) return baseSlug;

  const uniqueSuffix = Date.now().toString().slice(-6);

  return `${baseSlug}-${uniqueSuffix}`;
};
